import { Button, Card, Container } from 'react-bootstrap';
import { useCreateCheckoutSessionMutation } from '../slices/stripeApiSlice';
import { useGetProductsQuery } from '../slices/productsApiSlice';
import Meta from './Meta';
import useQueryParams from '../hooks/useQueryParams';
import { useEffect } from 'react';
import SearchResults from './SearchResults';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const PlanDisplay = ({ plan }) => {
  const userInfo = useSelector((state) => state.auth.userInfo);
  const navigate = useNavigate();

  const [createCheckoutSession, { isLoading }] = useCreateCheckoutSessionMutation();

  const [query, updateQueryParams] = useQueryParams();

  const pageNumber = parseInt(query.page, 10) || 1;
  const maxPrice = plan.itemPriceLimit ? parseInt(plan.itemPriceLimit, 10) : '';

  useEffect(() => {
      window.scrollTo(0, 0);
  }, [pageNumber, query]);

  const { data: productsData, isLoading: productsLoading, error: productsError } = useGetProductsQuery({
    pageNumber,
    maxPrice,
  });

  const handleCheckout = async () => {
    if (!userInfo) {
      toast.info('ログインをして、サブスクリプションを楽しみましょう！');
      navigate('/login');
      return;
    }

    if (userInfo?.subscription) {
      navigate('/subscription-status');
      toast.info('すでにサブスクリプションに加入しています。');
      return;
    }

    try {
      // サーバーにプランIDを渡してチェックアウトセッションを作成
      const { url } = await createCheckoutSession({ subscriptionId: plan.id }).unwrap();
      // セッションIDに基づいてStripeのチェックアウトページにリダイレクト
      window.location.href = url;
    } catch (error) {
      console.error('Failed to create checkout session:', error);
    }
  };

  return (<Container>
    <Meta
      title={`${plan.name} | ふるぷら`}
      description={`${plan.name}のプラン詳細ページです。`}
      keywords={['サブスクリプション', 'プラン', '古着', 'レンタル', 'ファッション', 'おしゃれ', 'ふるぷら']}
      robots='index, nofollow'
    />
    <Card className="text-center">
      <Card.Header>
        <h2 className='mb-0'>{plan.name}</h2>
      </Card.Header>
      <Card.Body>
        <Card.Text>
          ¥ {plan.price} / 月<br />
          {plan.itemPriceLimit} 円以下の服を、{plan.maxItems}着まで無料でレンタル可能。<br />
          何度でも交換し放題
        </Card.Text>
        <Button variant="primary" onClick={handleCheckout} disabled={isLoading}>
          お支払い画面へ
        </Button>
      </Card.Body>
    </Card>
    <Card className='mt-3'>
      <Card.Header className='text-center'>レンタルできる商品の例</Card.Header>
      <Card.Body>
        {productsLoading ? (
          <p>Loading...</p>
        ) : productsError ? (
          <p>Error: {productsError.message}</p>
        ) : (
          <SearchResults
              productsData={productsData}
              keyword={''}
          />
        )}
      </Card.Body>
    </Card>
  </Container>);
};

export default PlanDisplay;
